/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const DEFAULT_APP_CONFIG = {
  SIGNER_PK:
  "-----BEGIN PUBLIC KEY-----\nMIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDHGiWP4kcFhu13uRAiamqpJIqj\nnvVT3cwD4U5kWnY5iAiZm1RJ8i3FLiVWtVkSHFyfr7emsjUJb+p3mcFkqYnXXtOj\n0oc64+iqMxg4B4cuOL3aAkshLk9S32lT5xz1m+uP1yzz6RfcmrIyo0ZFrA7UXL8a\nopJoca1BL6Sz3M7WFQIDAQAB\n-----END PUBLIC KEY-----",
  defaultLoading: {
    image:
      "https://s3.ap-south-1.amazonaws.com/io.klefki.parametro/barometer-logo-v2.png",
    titleNormalText: "Loading",
    titleBoldText: "Page...",
    description: "This might take few seconds, Please wait !",
  },
  platformSemantics: {
    semantics: {
      holder: "Users",
      holders: "Users",
      issuer: "Organization",
    },
    Holders: {
      title: "Users",
    },
    HoldersGroups: {
      title: "Users Group",
    },
    DashboardIssuerAnalysis: {
      title: "Organization",
    },
  },
  partialPaymentPercent: 60,
};
